import { createReducer, on } from "@ngrx/store";
import * as fetchPendingRequestAction from '../action/fetch-pendingRequest.action'
import { pendingState } from "../user-profile.state";
import * as functionalityAction from '../action/user-profile-funcionality.action'

const initialState: pendingState = {
    requestAccessPending: null,
    tableUpdate: null,
    filteredTableData: null
};

export const fetchUserPendingRequestReducer = createReducer(
    initialState,
    on(
        fetchPendingRequestAction.fetchPendingRequestActionSuccess,
        (state: pendingState, { requestAccessPending }) => ({
            ...state,
            requestAccessPending,
        })
    ),
    on(fetchPendingRequestAction.updateTable, (state: pendingState, { tableData }) => ({
        ...state,
        tableUpdate: {
            ...state.tableUpdate,
            salesTableData: tableData.salesTableData,
            notSalesTableData: tableData.notSalesTableData,
            salesTablecolumn: tableData.salesTablecolumn,
            notSalesTablecolumn: tableData.notSalesTablecolumn
        }
    })),
    on(functionalityAction.updateCheckBox, (state: pendingState, { updatedData, internal }) => {
        if (internal) {
            const salesData = state.tableUpdate.salesTableData.map((item) => {
                if (item.LegalEntity === updatedData[0].LegalEntity) {
                    return {
                        ...item,
                        salesRep: updatedData[0].salesRep,
                        updatedValue: true
                    };
                }
                return item;
            });
            return {
                ...state,
                tableUpdate: {
                    ...state.tableUpdate,
                    salesTableData: salesData,
                },
            };
        } else {
            const notSalesData = state.tableUpdate.notSalesTableData.map((item) => {
                if (item.LegalEntity === updatedData[0].LegalEntity) {
                    return {
                        ...item,
                        customerAdmin: updatedData[0].customerAdmin,
                        requester: updatedData[0].requester,
                        approver: updatedData[0].approver,
                        updatedValue: true
                    };
                }
                return item;
            });
            return {
                ...state,
                tableUpdate: {
                    ...state.tableUpdate,
                    notSalesTableData: notSalesData,
                },
            };
        }
    }), on(functionalityAction.clearUserProfile,
        () => ({
            ...initialState
        })),
    on(functionalityAction.filteredTableDataAction, (state: pendingState, { filteredTableData }) => ({
        ...state,
        filteredTableData: filteredTableData
    })),
)
